import Navbar from "../Components/Navbar";
import Home from "../Components/Home";
import Welcome from "../Components/Welcome";
import Rooms from "../Components/Room";
import Coutrallam from "../Components/Coutralam";
import Attractions from "../Components/Attractions";
import Footer from "../Components/Footer";

function HomePage() {
  return (
    <>
      <Navbar />
      <Home />
      <Welcome />
      <Rooms />
      <Coutrallam />
      <Attractions />
      <Footer />


    </>
  );
}

export default HomePage;